import { normalize } from 'normalizr';
import { query } from '@/dex-shared/helpers/graphql';
import { slugifyString } from '@/dex-shared/lib/StringHelper';
import { list } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_MATERIAL_RECOMMENDATIONS({ commit }: any, listId: number) {
    const response = await query(
      `query GetMaterialRecommendations ($listId: Int!) {
      recommendedBoardOfList(listid: $listId) {
        nodes {
          id
          title
        }
      }
      recommendedBoardSectionOfList(listid: $listId) {
        nodes {
          id
          title
        }
      }
    }`,
      {
        listId,
      },
    );
    commit('SET_MATERIAL_RECOMMENDATIONS', response.data);
  },
  async GET_LIST_PERFORMANCE_BY_USER({ commit }: any, listId: number) {
    const response = await query(
      `query GetListPerformance($listId: Int!){
        listById(id: $listId) {
          id
          totalQuestions
          performanceByUser {
            nodes {
              userOfReplies {
                id
                name
                email
              }
              firstRepliesOfQuestions
            }
          }
        }
      }`,
      {
        listId,
      },
    );
    if (response.data.listById) {
      const listPerformance = response.data.listById.performanceByUser.nodes;
      commit('SET_LIST_PERFORMANCE_USER_REPLIES', { listId, listPerformance });
    }
  },
  async GET_LIST_PERFORMANCE({ commit }: any, listId: number) {
    const response = await query(
      `query GetListPerformance($listId: Int!){
        listById(id: $listId) {
          id
          listItemsByListId(filter: {
            questionId: {
              isNull: false
            }
          }) {
            nodes {
              id
              listId
              position
              questionByQuestionId {
                id
                distinctUserReplies(listId: $listId)
              }
            }
          }
        }
      }`,
      {
        listId,
      },
    );
    if (response.data.listById) {
      const normalizedResponse = normalize(response.data.listById, list);
      commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
    }
  },
};
